import type { Translation } from './en'

export const ar: Translation = {
  app: {
    tagline: 'أسواق أذكى.. فرص أكبر',
  },
  nav: {
    home: 'الرئيسية',
    markets: 'الأسواق',
    convert: 'تحويل',
    forecasts: 'التوقعات',
    more: 'المزيد',
    pro: 'GlobalX Pro',
    settings: 'الإعدادات',
    search: 'ابحث عن عملة…',
    menu: 'التنقل الرئيسي',
    skip: 'تخطَّ إلى المحتوى',
  },
  common: {
    demo: 'تجريبي',
    demoData: 'بيانات تجريبية — ليست أسعارًا حقيقية',
    liveRatesNotice: 'الأسعار حقيقية مع مصدرها ووقتها. بعض الأسواق لم تُربط بعد، والتوقعات تصميم تجريبي.',
    ad: 'إعلان',
    adSlot: 'مساحة إعلانية (الخطة المجانية)',
    viewAll: 'عرض الكل',
    close: 'إغلاق',
    comingSoon: 'قريبًا',
    justNow: 'الآن',
    source: 'المصدر',
    updated: 'آخر تحديث',
    type: 'نوع السعر',
    precision: 'الدقة',
    notFound: 'الصفحة غير موجودة',
    backHome: 'العودة للرئيسية',
    proBadge: 'PRO',
  },
  home: {
    heroTitle: 'أسواق أذكى.. فرص أكبر',
    heroSubtitle: 'حوّل بين العملات فورًا، وتابع الذهب والفضة والنفط والعملات الرقمية في مكان واحد.',
    quick: 'تحويلات سريعة',
    snapshot: 'لمحة عن الأسواق',
    movers: 'الأكثر حركة',
    openConverter: 'المحوّل الكامل',
    proTitle: 'GlobalX Pro',
    proText: 'بلا إعلانات، مع تنبيهات متقدمة وتحليلات أعمق.',
    proCta: 'اكتشف Pro',
    point1: 'كل سعر يظهر مع مصدره ووقت تحديثه',
    point2: 'دقة تتبع المنازل العشرية لكل عملة',
    point3: 'العربية والإنجليزية، فاتح وداكن',
  },
  converter: {
    title: 'محوّل العملات',
    from: 'من',
    to: 'إلى',
    amount: 'المبلغ',
    swap: 'عكس اتجاه التحويل',
    rate: 'سعر الصرف',
    copy: 'نسخ النتيجة',
    copied: 'تم النسخ',
    popular: 'مبالغ شائعة',
    pinPair: 'حفظ الزوج',
    unpinPair: 'إزالة الزوج المحفوظ',
    savedPairs: 'أزواج محفوظة',
    multiTitle: 'بعملات أخرى',
    multiHint: 'عملاتك المفضلة بالمبلغ الحالي',
    invalid: 'أدخل مبلغًا صحيحًا',
    select: 'اختر العملة',
    search: 'ابحث بالرمز أو الاسم',
    noResults: 'لا توجد عملة تطابق «{{q}}»',
    favorites: 'المفضلة',
    popularList: 'الأكثر استخدامًا',
    all: 'كل العملات',
    addFavorite: 'إضافة إلى المفضلة',
    removeFavorite: 'إزالة من المفضلة',
    stale: 'قد تكون هذه الأسعار قديمة. آخر تحديث: {{time}}',
    offline: 'أنت غير متصل. نعرض آخر أسعار محفوظة.',
    cached: 'تعذّر الوصول لخدمة الأسعار. نعرض آخر أسعار محفوظة على هذا الجهاز.',
    loadError: 'تعذّر تحميل أسعار الصرف. تحقق من الاتصال وحاول مجددًا.',
    retry: 'إعادة المحاولة',
    dailyRate: 'سعر يومي',
    yerNotice: 'الريال اليمني: هذا هو السعر الرسمي المرجعي، وأسعار السوق في عدن وصنعاء تختلف عنه كثيرًا.',
    deviation: 'تختلف المصادر بنسبة {{pct}}% لعملة {{code}}؛ تعامل مع هذا السعر بحذر.',
    unavailable: 'السعر غير متوفر لـ {{code}}',
    kind: {
      reference: 'سعر مرجعي',
      delayed: 'سعر متأخر',
      live: 'سعر لحظي',
      demo: 'بيانات تجريبية',
    },
    kindHint: {
      reference: 'سعر مرجعي متوسط للسوق. البنوك والصرافات تضيف هوامشها ورسومها الخاصة.',
      delayed: 'سعر سوق متأخر من المزوّد، وليس سعر تنفيذ.',
      live: 'سعر لحظي من مصدر مرخّص.',
      demo: 'قيم توضيحية لتصميم الواجهة فقط. لا تعتمد عليها في أي قرار.',
    },
    precision: '{{n}} منازل عشرية لعملة {{code}}',
  },
  markets: {
    title: 'الأسواق',
    subtitle: 'العملات والكريبتو والمعادن الثمينة والطاقة — لكل فئة قسمها المستقل.',
    tabs: { all: 'الكل', watchlist: 'المتابعة', fiat: 'العملات', crypto: 'الرقمية', gold: 'الذهب', silver: 'الفضة', oil: 'النفط' },
    asset: 'الأصل',
    price: 'السعر',
    change: '24 ساعة',
    trend: 'اتجاه 7 أيام',
    dataNote:
      'الأسعار مرجعية أو متأخرة من المصادر المذكورة، وليست أسعار تنفيذ للتداول. أسعار النفط إغلاقات يومية ينشرها المصدر بعد عدة أيام.',
    unavailable: 'غير متاح',
    unavailableText: 'هذا السعر غير متاح مؤقتًا من مصدره. حاول لاحقًا.',
    comingSoonText: 'سيُربط هذا السوق بمصدر مجاني مرخّص في خطوة قادمة. لا نعرض أسعارًا مؤقتة بدلًا منه.',
    loadError: 'تعذّر تحميل أسعار الأسواق. تحقق من الاتصال وحاول مجددًا.',
    historyError: 'تعذّر تحميل الرسم لهذه الفترة.',
    since: 'مقارنة بإغلاق {{date}}',
    last24h: 'خلال آخر 24 ساعة',
    sources: 'المصادر:',
    changeBasis: 'أساس التغير',
    unit: 'الوحدة',
    about: 'عن هذا السعر',
    notFound: 'الأصل غير موجود',
    openInConverter: 'فتح في المحوّل',
    priceFrom: 'السعر: {{source}}، {{time}}',
    chartFrom: 'الرسم: {{source}}',
    moversNote: 'التغير مقارنة بالإغلاق السابق (الكريبتو: آخر 24 ساعة).',
    notAdvice: 'للمعلومات فقط — ليست نصيحة استثمارية.',
  },
  assets: {
    XAU: 'الذهب',
    XAG: 'الفضة',
    BRENT: 'نفط برنت',
    WTI: 'نفط WTI',
    BTC: 'بيتكوين',
    ETH: 'إيثريوم',
    SOL: 'سولانا',
    EURUSD: 'يورو/دولار',
    GBPUSD: 'جنيه/دولار',
    USDJPY: 'دولار/ين',
    USDCHF: 'دولار/فرنك سويسري',
    USDTRY: 'دولار/ليرة تركية',
    USDEGP: 'دولار/جنيه مصري',
    perOunce: 'للأونصة',
    perBarrel: 'للبرميل',
  },
  chart: {
    periods: { '1D': 'يوم', '1W': 'أسبوع', '1M': 'شهر', '3M': '3 أشهر', '1Y': 'سنة', ALL: 'الكل' },
    high: 'الأعلى',
    low: 'الأدنى',
    open: 'الافتتاح',
    period: 'فترة الرسم',
    periodChange: 'تغير الفترة',
  },
  forecasts: {
    title: 'التوقعات',
    subtitle: 'نظرة احتمالية — منفصلة عن التحليل الوصفي.',
    notReady: 'لا توجد توقعات فعلية بعد',
    notReadyText:
      'لن تُنشر التوقعات إلا بعد توفر بيانات كافية ومنهجية مختبرة تاريخيًا. التصميم أدناه يستخدم بيانات تجريبية.',
    horizon: 'الأفق الزمني',
    horizons: { '1M': 'شهر', '3M': '3 أشهر', '6M': '6 أشهر', '12M': '12 شهرًا' },
    scenarios: 'السيناريوهات',
    bull: 'صعودي',
    base: 'أساسي',
    bear: 'هبوطي',
    range: 'النطاق',
    probability: 'الاحتمال',
    band: 'نطاق توضيحي',
    history: 'السعر التاريخي',
    notComputed: 'غير محسوب',
    demoNote: 'معاينة للتصميم بقيم تجريبية — ليست توقعًا.',
    methodology: 'المنهجية',
    methodologyText:
      'المخطط: نطاقات احتمالية تُقدّر من التقلب التاريخي، وتُقيَّم باختبار تاريخي (نسبة التغطية ومعايرة النطاقات) قبل النشر.',
    uncertainty: 'عدم اليقين',
    uncertaintyText:
      'تتسع النطاقات كلما طال الأفق. قد تتحرك الأسواق خارج أي نطاق بسبب أحداث لا يلتقطها أي نموذج.',
    disclaimer: 'التوقعات احتمالية وليست ضمانًا، ولا تُعد نصيحة استثمارية.',
  },
  pro: {
    title: 'GlobalX Pro',
    subtitle: 'أدوات أكثر لمن يتابع الأسواق عن قرب.',
    free: 'مجاني',
    pro: 'Pro',
    monthly: 'شهري',
    yearly: 'سنوي',
    perMonth: '/ شهريًا',
    perYear: '/ سنويًا',
    hypothesis: 'الأسعار فرضيات أولية قيد المراجعة — الاشتراكات غير متاحة بعد.',
    cta: 'الاشتراك قريبًا',
    features: {
      converter: 'محوّل فوري مع المفضلة',
      markets: 'أقسام الأسواق والرسوم',
      ads: 'بدون إعلانات',
      alerts: 'تنبيهات أسعار متقدمة',
      watchlists: 'قوائم متابعة أوسع',
      charts: 'رسوم وتحليلات أعمق',
      compare: 'مقارنة الأصول',
      reports: 'تقارير مخصصة',
    },
  },
  settings: {
    title: 'الإعدادات',
    appearance: 'المظهر',
    language: 'اللغة',
    theme: 'الوضع',
    themes: { system: 'تلقائي', dark: 'داكن', light: 'فاتح' },
    digits: 'الأرقام',
    digitStyles: { latn: '123', arab: '١٢٣' },
    data: 'البيانات والخصوصية',
    dataText: 'تُحفظ مفضلتك وقائمة متابعتك وتفضيلاتك على هذا الجهاز فقط، ولا يلزم إنشاء حساب.',
    reset: 'مسح البيانات المحلية',
    resetDone: 'تم مسح البيانات المحلية',
    about: 'عن البيانات',
    aboutLink: 'عن GlobalX والخصوصية',
    aboutText:
      'الأسعار المعروضة في هذه المرحلة تجريبية. بعد ربط المزودين سيظهر مع كل سعر مصدره ووقت تحديثه ونوعه.',
  },
  watch: {
    add: 'إضافة إلى المتابعة',
    remove: 'إزالة من المتابعة',
    full: 'قائمة المتابعة ممتلئة ({{n}} أصول في الخطة المجانية)',
    emptyTitle: 'قائمة المتابعة فارغة',
    emptyText: 'اضغط النجمة على أي أصل لمتابعته هنا. حتى {{n}} أصول، تُحفظ على هذا الجهاز.',
    missing: 'لم يعد متاحًا',
  },
  more: { title: 'المزيد' },
  about: {
    title: 'عن GlobalX والخصوصية',
    subtitle: 'ما الذي يحفظه GlobalX، ومن أين تأتي الأسعار، وكيف تحذف بياناتك.',
    deviceTitle: 'محفوظ على جهازك فقط',
    deviceText:
      'اللغة والوضع ونوع الأرقام والعملات المفضلة والأزواج المحفوظة وقائمة المتابعة وآخر تحويل وآخر أسعار وصلت تُحفظ في هذا المتصفح (التخزين المحلي) ليعمل التطبيق بسرعة ودون اتصال.',
    noAccount: 'لا يلزم إنشاء حساب. لا يضع GlobalX ملفات تعريف تتبّع، ولا توجد إعلانات أو تحليلات في هذه المرحلة.',
    serversTitle: 'خوادمنا',
    serversText:
      'لعرض الأسعار يطلبها التطبيق من خوادم GlobalX (Supabase، منطقة فرانكفورت)، التي تجلبها من المصادر أدناه وتحتفظ بنسخة مؤقتة من الأسعار فقط — دون أي بيانات شخصية.',
    hostsText:
      'كأي موقع، قد يعالج مزوّدو الاستضافة (Cloudflare وSupabase) بيانات تقنية مثل عنوان IP لتقديم الخدمة وحمايتها، وفق سياساتهم.',
    deleteTitle: 'حذف بياناتك',
    deleteText: 'استخدم «مسح البيانات المحلية» في الإعدادات، أو امسح بيانات هذا الموقع من المتصفح.',
    sourcesTitle: 'مصادر البيانات',
    sourcesText: 'يظهر مع كل سعر في التطبيق مصدره ووقت تحديثه ونوعه. المصادر المستخدمة أو المجهّزة حاليًا:',
    source: {
      frankfurter: 'أسعار صرف مرجعية يومية وتاريخ الذهب والفضة',
      exchangerate: 'أسعار صرف مرجعية (عند تفعيلها)',
      goldapi: 'أسعار الذهب والفضة الفورية',
      eia: 'أسعار إغلاق برنت وWTI اليومية',
      cmc: 'أسعار العملات الرقمية (عند تفعيلها)',
      lcw: 'أسعار العملات الرقمية وتاريخها (عند تفعيلها)',
      charts: 'رسم المخططات',
    },
    disclaimerTitle: 'تنبيه مهم',
    disclaimerText:
      'الأسعار قيم مرجعية أو متأخرة للمعلومات فقط — وليست أسعار تنفيذ للتداول — ولا شيء في GlobalX يُعد نصيحة استثمارية. البنوك والصرافات تطبّق أسعارها ورسومها الخاصة.',
    updated: 'آخر تحديث: {{date}}',
  },
}
